import React from "react"
import OfflineQueue from "../../OfflineQueue.jsx"

export default function OfflineQueuePage() {
  return <OfflineQueue />
}

